import { Injectable } from "@angular/core";
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  readonly formats = {
    full: 'EEE, MM/dd/yyyy, hh:mm a',
    long: 'MM/dd/yyyy, hh:mm a',
    time: 'hh:mm a',
    dateString: 'yyyy-MM-dd',
    date: 'MMMM dd, yyyy',
    simpleDate: 'MM/dd/yyyy',
    short: 'MM/dd hh:mm a',
    day: 'EEE, MM/dd/yyyy'
  };

  public getDateString(date: Date) {
    return formatDate(date, this.formats.dateString, "en-US")
  }

  public getsimpleDate(date: Date) {
    if ('Invalid Date'.toLowerCase() == date?.toString().toLowerCase()) {
      return null;
    }
    return formatDate(date, this.formats.simpleDate, "en-US")
  }

  public getLongDate(date: Date) {
    return formatDate(date, this.formats.long, "en-US")
  }

  public getIsoDate(date = null) {
    if (!date) {
      return new Date().toISOString();
    }
    return new Date(date).toISOString();
  }

  getDateWithoutTimeZoneString(date): string {
    return date ? (date.split('T'))[0] : null;
  }


}

